import p100 from "./img/famille.jpg"
import p099 from "./img/fond.jpg"
import v098 from "./video/24dec.mp4"
import p097 from "./img/sapin.jpg"
import a096 from "./sfx/dometcecile.aac"
import p095 from "./img/paddle.jpg"
import p094 from "./img/serieux.jpg"
import p093 from "./img/chef.jpg"
import v092 from "./video/twist.mp4"
import p091 from "./img/bonono.png"
import p090 from "./img/galette2025.jpg"
import p089 from "./img/slever.jpg"
import p088 from "./img/victor.jpg"
import v086 from "./video/pyves.mp4"
import p085 from "./img/isa+totof.jpg"
import p084 from "./img/charlie.jpg"
import v083 from "./video/christophe.mp4" 
import p082 from "./img/elvis.jpg"
import p081 from "./img/balaisev.jpg"
import v080 from "./video/novaflemme.mp4"
import v078 from "./video/bertin.mp4"
import v077 from "./video/manu.mp4"
import v076 from "./video/josette.mp4"
import p075 from "./img/montre.jpg"
import p074 from "./img/force.jpg"
import p073 from "./img/rouj.jpg"
import v072 from "./video/victoire.mp4"
import p071 from "./img/victoire.jpg"
import v070 from "./video/chiassepunk.mp4"
import p069 from "./img/lac.jpg"
import p068 from "./img/montreux.jpg"
import p067 from "./img/gorges.jpg"
import p066 from "./img/ptitnoel.JPG"
import p065 from "./img/main.jpg"
import v064 from "./video/fanfan.mp4"
import v063 from "./video/guy.mp4"
import p062 from "./img/chovsouri.jpg"
import p061 from "./img/escala.jpg"
import p060 from "./img/louvre.jpg"
import v059 from "./video/blues.mp4"
import p058 from "./img/elviss.jpeg"
import p057 from "./img/francky.jpg"
import p056 from "./img/litpetits.jpg"
import v055 from "./video/claire.mp4"
import p054 from "./img/pointe.jpg"
import p053 from "./img/faberic.jpg"
import a052 from "./sfx/faberic.m4a"
import p051 from "./img/miche.jpg"
import v050 from "./video/erdre.mp4"
import p049 from "./img/pape.jpg"
import p048 from "./img/funes.jpg"
import w001 from "./img/agnain.gif"
import w002 from "./sfx/tout_pete.mp3"
import w003 from "./img/gneee.jpg"
import p041 from "./img/tonton.jpg"
import v040 from "./video/val.mp4"
import v039 from "./video/renault1.mp4"
import v038 from "./video/renault2.mp4"
import v037 from "./video/renault3.mp4"
import p034 from "./img/berangerie.jpg";
import v032 from "./video/quimperle.mp4";
import v031 from "./video/rire.mp4";
import p029 from "./img/martz.jpg";
import p028 from "./img/marc.jpg";
import v027 from "./video/ledzep.mp4";
import p024 from "./img/talb2.jpg";
import p022 from "./img/metro.jpg";
import v021 from "./video/blandine.mp4";
import p020 from "./img/planche.jpg";
import v019 from "./video/annie.mp4";
import p018 from "./img/baton.jpg";
import p017 from "./img/mariage.jpg";
import p016 from "./img/poele.jpg";
import p015 from "./img/sommet.jpg";
import p014 from "./img/helltemple.png";
import p013 from "./img/rock.jpg";
import p012 from "./img/paddy.jpg";
import p011 from "./img/tartes.jpg";
import p010 from "./img/deal.png";
import v009 from "./video/RenaudSechian.mp4";
import p007 from "./img/mamie.jpg";
import p005 from "./img/bros.jpg";
import p004 from "./img/velo.jpg";
import p002 from "./img/diandra.jpg";

const v087 = "https://www.youtube.com/embed/HqAGmKrCFms";
const v079 = "https://www.youtube.com/embed/rnTyHIOZTJ0";
const v036 = "https://www.youtube.com/embed/4BdhsNJziT0";
const v035 = "https://www.youtube.com/embed/rB6OlJqV1rQ";
const v033 = "https://www.youtube.com/embed/tS23C4EGCQs";
const v030 = "https://www.youtube.com/embed/eweo4sITguA";
const v026 = "https://www.youtube.com/embed/GI5cH6ezWFU";
const v025 = "https://www.youtube.com/embed/L6TJWem-k0A";
const v023 = "https://www.youtube.com/embed/9je3ROkGju0";
const v008 = "https://www.youtube.com/embed/VQIRZCj7DIk";
const v006 = "https://www.youtube.com/embed/6Z9m2-VH2m8";
const v003 = "https://www.youtube.com/embed/gS0ay6L1A6w";
const v001 = "https://www.youtube.com/embed/Hjqs8YIB7ys";
const v000 = "https://www.youtube.com/embed/WPJ7lo1Gc4Q";

var contents_1 = [
{subtitle:"Coucou papa !",
  text:`Comme tu l'avais fait remarquer, il ne te reste plus que 100 jours avant la retraite.<br>
  Alors moi et mes p'tits potes, mois de décembre oblige, on a eu l'idée de rendre cette période un peu plus sympa à égrener : sous la forme d'un petit calendrier avec des petits mots, photos, souvenirs et d'autres surprises chaque jour !<br>
  Tu peux choisir entre afficher une seule carte à la fois, ou toutes côte à côte avec le bouton <i>Change layout</i>.<blockquote>- Clément</blockquote>`,
  media:{type:"IMAGE", source:{url:p100}}},
{subtitle:"De quoi t'as l'Erdre ?",
  text:"Une image de fond pour un même message de fond.<br>Allez, encore 99 jours et t'auras fini de ramer !", 
  media:{type:"IMAGE", source:{url:p099}}},
{subtitle:"Réveil ? Oh non, sagement chez nos parents !",
  text:"We're caught in a trap !", 
  media:{type:"VIDEO", source:{url:v098, type:"video/mp4"}}},
{subtitle:"Joyeux Noël !",
  text:"Dernier Noël avant la fin du monde (du travail) !", 
  media:{type:"IMAGE", source:{url:p097}}},
{subtitle:"Message de Dom & Cécile à domicile (à dos d'missile) !",
  media:{type:"VIDEO", source:{url:a096, type:"audio/aac"}}},
{subtitle:"Y a paddle pour ça !",
  text:"Bon, peut-être pas, mais y a une saison, quand même !<br>C'est vrai que l'été nous parait bien lointain... mais le prochain aura, je pense, une saveur particulière !",
  media:{type:"IMAGE", source:{url:p095}}},
{subtitle:"En retard !",
  text:`Oups, j'ai pas été très assidu pour ce jour-là... Pas très suisse de ma part !<br>
  Tu vas finir par croire que je ne prends pas ce projet très au sérieux...? 🫣<br>
  Puisses-tu un jour me pardonner cet impair de famille !`,
  media:{type:"IMAGE", source:{url:p094}}},
{subtitle:"Ça suisse son cours",
  text:`Ah, voilà qui est un peu plus crédible !<br>
  Allez hopopop Cruchot... euh, Clément ! On complète le calendrier et plus vite que ça !<br>
  Père pas de temps !`,
  media:{type:"IMAGE", source:{url:p093}}},
{subtitle:"C'était vraiment pas twist !",
    text:"En dépit des circonspections du côté italien <s>de la Force</s> des Bauchet, rien ne décourage les twisteurs du vendredi soir !",
    media:{type:"VIDEO", source:{url:v092, type:"video/mp4"}}},
{subtitle:"Banané !",
  text:`Il est maintenant temps de dire adieu à cette année 2024 à la con qui ne manquera à personne, et de débouler dans ce deuxième quart de siècle comme Lucien chez ses parents ci-dessus !<br>
  Bon bout d'an !`,
  media:{type:"IMAGE", source:{url:p091}}},
{subtitle:"Rien à lui janvier !",
  text:`Pas de temps à perdre, c'est déjà la saison des Rois !<br>
  Pas pâtissier pour un sou, notre père hors pair jamais ne galère : rien ne saurait égaler ses galettes !`,
  media:{type:"IMAGE", source:{url:p090}}},
{subtitle:"Dernier trimestre !",
  text:`Dernier trimestre à tirer, le reste est déjà racheté !<br>
  Bon retour à la réalité post-fêtes, et bon courage pour 2025 !`,
  media:{type:"IMAGE", source:{url:p089}}},
{subtitle:"Victorieux !",
  text:`Encore un qui échappe au Club des 27... c'est pas plus mal !`,
  media:{type:"IMAGE", source:{url:p088}}},
{subtitle:"Les copains d'Arvor !",
  text:`Nous sommes en 2025 et vous regardez <s>l'ancêtre d'</s> Internet, bonsoir !`,
  media:{type:"VIDEO", source:{url:v087, type:"video/mp4"}}},
{subtitle:"Message de Pierre-Yves !",
  text:``,
  media:{type:"VIDEO", source:{url:v086, type:"video/mp4"}}},
{subtitle:"Message d'Isabelle & Totof !",
  text:`Bonjour Pascal alias le breton, Maurice.<br>
Mission impossible pour résumer notre longue amitié. L'Oustalet, Lavilliers. Coluche, le salon nautique... résument nos moments inoubliables.<br>
Alors la retraite va te permettre de peaufiner tes imitations pour nous enchanter lors de nos prochaines rencontres.<br>
Force et confiance pour cette nouvelle tranche de vie.`,
  media:{type:"IMAGE", source:{url:p085}}},
{subtitle:"Où t'es, Charlie ?",
  text:`Il y a exactement 10 ans, l'année commençait très mal...<br>
  Alors pour la mémoire, j'ai repensé à ce fameux hors-série qui a longtemps trôné chez nous, le premier Charlie Hebdo que j'ai ouvert, et dont j'avais essayé de saisir toutes les faces de son humour du haut de mes 9 ans, à l'instar des Austin Powers que je découvrais alors !<br>
 (On l'a toujours, d'ailleurs ?...)`,
  media:{type:"IMAGE", source:{url:p084}}},
{subtitle:"Message de Christophe de la Chenelière !",
  media:{type:"VIDEO", source:{url:v083, type:"video/mp4"}}},
{subtitle:"Who is the King ?",
  text:`C'est aujourd'hui que ton cadeau de Noël s'active ! It's now or never !`,
  media:{type:"IMAGE", source:{url:p082}}},
{subtitle:"Pas d'malaise, Pascal !",
  text:`À l'aise sur la falaise !`,
  media:{type:"IMAGE", source:{url:p081}}},
{subtitle:"Message de... Nova ?",
  text:`La seule existence de Nova provoque une novague de flemme implacable...<br>Et on dirait bien que maman se l'est prise de plein fouet !`,
  media:{type:"VIDEO", source:{url:v080, type:"video/mp4"}}},
{subtitle:"Les gens marris le peinent",
  text:`On en aurait presque oublié l'événement principal de la semaine !`,
  media:{type:"VIDEO", source:{url:v079, type:"video/mp4"}}},
{subtitle:"Message des Bertin !",
  media:{type:"VIDEO", source:{url:v078, type:"video/mp4"}}},
{subtitle:"Message de Manu, 'tention !",
  media:{type:"VIDEO", source:{url:v077, type:"video/mp4"}}},
{subtitle:"Jésus, Marie, Josette !",
  media:{type:"VIDEO", source:{url:v076, type:"video/mp4"}}},
{subtitle:"Un quart ? Que fous-je ? ",
  text:`Eh bah, déjà un quart de passé ! T'y crois, toi ?`,
  media:{type:"IMAGE", source:{url:p075}}},
{subtitle:"Pour être bon en physique, faut que vous vous leviez tôt !",
  text:`Voici un autre des livres de la maison qui ont façonné mon intérêt pour la mécanique (pas celle avec les clés plates et le cambouis !) et plus généralement la physique (<i>le</i> physique vint seulement après) !<br>
  Tout ça pour faire un bac S (comme <i>Sans mention</i>) et 6 ans d'études en informatique, est-ce que ça pèse dans la balance ?<br>
  En tout cas, ça n'a pas manqué de travail, de frictions, de résistance et de tensions pour l'électron libre que je suis !`,
  media:{type:"IMAGE", source:{url:p074}}},
{subtitle:"Pascal au bistrot !",
  text:`Oh bah ça va, y a pas à rougir comme ça (et je parle pas du verre) !`,
  media:{type:"IMAGE", source:{url:p073}}},
{subtitle:"La Victoire ou que dalle !",
  text:`Message de ta fille !`,
  media:{type:"VIDEO", source:{url:v072, type:"video/mp4"}}},
{subtitle:"Victoire hour",
  text:`Est-ce que la vraie victoire, ça ne serait pas en fait ce décor et cet éclairage incroyables ? 😭`,
  media:{type:"IMAGE", source:{url:p071}}},
{subtitle:"Daft Pauvre",
  text:`On pourra dire à Valentin et Adèle que c'était nous, les Daft Punk ! 🤖👨‍🚀`,
  media:{type:"VIDEO", source:{url:v070, type:"video/mp4"}}},
{subtitle:"Mais qu'est-ce qu'on fout là, Clément ?!",
  text:`Mais saââââlut ! 🏔️🫕🧀🏦🍫🐄<br>
  Ça, c'est un petit souvenir de votre voyage diplomatique pour négocier avec les plus hautes instances helvétiques l'acquisition de plusieurs biens de grande valeur (des bières) !<br>
  Après toute cette route, on allait quand même pas se Gégé... se gêner !`,
  media:{type:"IMAGE", source:{url:p069}}},
{subtitle:"Montreux-leur !",
  text:`Je ne suis pas venu ici pour enregistrer un album, d'autres l'ont déjà fait 53 ans avant ici-même...<br>Y a pas/plus le feu au lac ! 💜`,
  media:{type:"IMAGE", source:{url:p068}}},
{subtitle:"De la Suisse dans les idées",
  text:`On continue ce petit arc narratif suisse dans un autre, d'arc :<br>
  Après l'arc lémanique, l'arc jurassien ! Suivez le geek !`,
  media:{type:"IMAGE", source:{url:p067}}},
{subtitle:"Le p'tit Noël",
  text:`Je marque une petite pause dans la petite balade romande pour cette anecdote :<br>
  Quand j'étais petit, je croyais que le 25 janvier était aussi un jour spécial où on recevait des cadeaux... naïf que j'étais !<br>
  Cela dit, maintenant c'est à moitié vrai, puisque je suis payé le 25 du mois 😏<br>
  (Et aussi l'anniversaire de mon copain Nick, si tu te souviens !)`,
  media:{type:"IMAGE", source:{url:p066}}},
{subtitle:"Sont-y pas mignons ? 🥰",
  text:`Fin de la parent-thèse, retour au TAUBENLOCH ! SCHNELL !!`,
  media:{type:"IMAGE", source:{url:p065}}},
{subtitle:"Message de Fanfan !",
  text:`Ta plus grande Fan !`,
  media:{type:"VIDEO", source:{url:v064, type:"video/mp4"}}},
{subtitle:"Who's that Guy ? 🇺🇸",
  text:`Message de Guy, qui compte bien exercer son Deuxième Amendement !<br>
  Les milliardaires, à l'échafaud ! (Et les plombiers, au chauffe-eau !)`,
  media:{type:"VIDEO", source:{url:v063, type:"video/mp4"}}},
{subtitle:"Blague-Man Begins !",
  text:`Comment appelle-t-on des amies chauves-souris qui vivent ensemble ?<br><br><br><br><br><br><br><br><br><br>
  Une écholocation ! 🤡`,
  media:{type:"IMAGE", source:{url:p062}}},
{subtitle:"Quoi, ma gueule ? L'Escala, ma gueule ?",
  text:`Bon d'accord, c'était juste pour la Vannes ! 🥴`,
  media:{type:"IMAGE", source:{url:p061}}},
{subtitle:"Faut toujours que tu Louvre !",
  text:`D'après une obscure légende, Ieoh Ming Pei, le dessinateur du musée du Louvre, aurait en fait piqué l'idée à son ami égyptien Ali, pendant ses vacances.<br>
  Mais il s'était bien gardé de lui attribuer le crédit, le laissant dans l'oubli et l'injustice, sans jamais lui en reparler ensuite.<br><br>
  C'était le pire ami d'Al' !`,
  media:{type:"IMAGE", source:{url:p060}}},
{subtitle:"Nouveau mois, nouveau toi ?",
  text:`C'est reparti pour un mois qui fait vriller !`,
  media:{type:"VIDEO", source:{url:v059, type:"video/mp4"}}},
{subtitle:"Elvis.",
  text:`Elvis.<br>
  <b>ELVIS.</b><br>
  🪽🔩.`,
  media:{type:"IMAGE", source:{url:p058}}},
{subtitle:"Francky Jousset le restaurant !",
  text:`Un beau jour, un Bauchet embauché chez un boucher débauché était bouche bée : qu'il était mal embouché !<br>
  Bon bah, c'est bien beau, mais faut bouger ! On se rhabille, Bauchet !`,
  media:{type:"IMAGE", source:{url:p057}}},
{subtitle:"Bah alors ?",
  text:`On déclare pas ses petits-enfants en soute ?`,
  media:{type:"IMAGE", source:{url:p056}}},
{subtitle:"Le message et Claire",
  text:``,
  media:{type:"VIDEO", source:{url:v055, type:"video/mp4"}}},
{subtitle:"Toujours à la pointe, à faire le pitre !",
  text:`Il était une fois dans l'Ouest... Pascal et Esther au Finistère !`,
  media:{type:"IMAGE", source:{url:p054}}},
{subtitle:"Message de Fabienne et Éric, mais...",
  text:`J'ai eu beau essayer, pas moyen de glisser le message audio en plus de la photo dans la même carte !<br>
  (en fait je suis un escroc qui sait pas coder...)<br>
  Tant pis, je te le garde pour demain 😋`,
  media:{type:"IMAGE", source:{url:p053}}},
{subtitle:"\"Message\" de Fabienne & Éric !",
   text:`Et voilà ton attente bien récompensée !`,
   media:{type:"VIDEO", source:{url:a052, type:"audio/m4a"}}},
{subtitle:"À Miche-min !",
  text:`Et bah voilà, la première moitié des 100 jours est pour ainsi dire pliée ! Sortez le(s) Miche(s) !`,
  media:{type:"IMAGE", source:{url:p051}}},
{subtitle:"Sacré papascal, toujours à vouloir se faire remorquer !",
  text:`Allez, on sent que c'est pas facile donc on t'aide un peu pour la deuxième moitié :<br>
  Pour le 50ème jour avant l'impact, t'as pas besoin de ramer : profite d'une petite fugue au frais !`,
  media:{type:"VIDEO", source:{url:v050, type:"video/mp4"}}},
{subtitle:"Je pète, tu contre-pètes",
  media:{type:"IMAGE", source:{url:p049}}},
{subtitle:"Putting the Fun in Louis de Funès since 1994",
  text:`Plutôt à la masse que Fantômas, mais y avait déjà des signes !`,
  media:{type:"IMAGE", source:{url:p048}}}
]

var wtfContents = [{
  subtitle:"Les calculs sont tout nazes !", 
  text:`Hein ? Attends, quoi ? La date a été changée ?<br>
  Mais alors, ça veut dire que... je soustrais, je pose 3, je retiens 1, euuhhhh...<br>
  et du coup le mec euuuuhhh... par'emple euhhhh... booohhh...<br>
  Nan mais pasqueeeeeee... bon bahhhh... nan ?`,
  media:{type:"IMAGE", source:{url:w001, type:"image/gif"}}
},
{
  subtitle:"Ah bah barvo !", 
  text:`Ah bah c'est malin ! On s'enlève un jour de boulot mais ça m'en rajoute un !<br>
  Trou d'balleux, va !`,
  media:{type:"VIDEO", source:{url:w002, type:"audio/mp3"}}
},
{
  subtitle:"Problème technique, nique, nique", 
  text:`Mais pourquoi j'ai choisi ce métier, moi ?... <br>
  Voilà ce qui se passe quand on définit pas bien le cahier des charges dès le début :<br>
  Au premier imprévu, on a l'air CON COMME UN MANCHE SANS SON BALAI !`,
  media:{type:"IMAGE", source:{url:w003}}
},
]

var contents_2 = [
  {subtitle:"Retour à la normale !",
    text:`Bon ! C'était chelou, mais j'ai fait quelques bricoles, et tu n'y verras que du fun !<br>
    En attendant, j'ai ramassé ce petit bonhomme qui nous servira pour le message suivant !`,
    media:{type:"IMAGE", source:{url:p041}}},
  {subtitle:"Message de ton p'tit-fils (Presley) !",
    media:{type:"VIDEO", source:{url:v040, type:"video/mp4"}}},
  {subtitle:"Standing Renault-vation ! 1/3",
    text:`Voilà un petit triptyque de la part des Renault qui commence !`,
    media:{type:"VIDEO", source:{url:v039, type:"video/mp4"}}},  
  {subtitle:"Standing Renault-vation ! 2/3",
    text:`Souvent imité, jamais dégueulé !`,
    media:{type:"VIDEO", source:{url:v038, type:"video/mp4"}}}, 
  {subtitle:"Standing Renault-vation ! 3/3",
    text:`Les légendes et traditions se transmettent encore à l'oral !`,
    media:{type:"VIDEO", source:{url:v037, type:"video/mp4"}}},
  {subtitle:"Message de Taha !",
    text:`Puisque les mots ne sont jamais les mêmes pour exprimer ce qu'est le blues,<br>
    un expert en la matière s'est proposé pour délivrer un message qui se passe<br>
    de mots, dans la langue universelle qu'est justement le blues ! 🩵`,
    media:{type:"VIDEO", source:{url:v036, type:"video/mp4"}}},
  {subtitle:"Ah tiens, quand on parle du blues...",
    text:`Pour rester dans le sujet, je voudrais te partager une de mes plus belles découvertes de ces dernières années<br>
    parmi ce genre musical qui, un peu comme toi, a changé mon regard sur pas mal de choses et a su être là aux moments les plus importants 🩵`,
    media:{type:"VIDEO", source:{url:v035, type:"video/mp4"}}},
  {subtitle:"J'ai vu le couvreur, il m'a parlé de toit",
    text:`La Bérangerie qui sera bientôt barbecue-compatible pour les étés retraités ! 😉`,
    media:{type:"IMAGE", source:{url:p034}}},
  {subtitle:"Bienvenue dans la (drôle de) machine",
    text:`Voici un instrument bien inhabituel... mais il faut au moins ça pour jouer dignement du Pink Floyd !
    J'admets avoir eu très envie de m'en commander un, mais j'ai vu le prix... et plus Jamie Dupuis ! 🤡`,
    media:{type:"VIDEO", source:{url:v033, type:"video/mp4"}}},
  {subtitle:"Message de Michelle et Daniel !",
    text:`Quimperlé flacons, pourvu qu'on ait l'ivresse !`,
    media:{type:"VIDEO", source:{url:v032, type:"video/mp4"}}},
  {subtitle:"Attention, cette cascade a été réalisée par impro !",
    text:`Qui pourrait m'expliquer pourquoi la voiture est un endroit si propice au yoga du rire ?<br>
    En tout cas, je me prends à faire l'exercice de plus en plus : un jour, l'élève dépassera le kilomètre !`,
    media:{type:"VIDEO", source:{url:v031, type:"video/mp4"}}},
  {subtitle:"Black Donald",
    text:`Un gars que j'ai découvert aujourd'hui grâce à un collègue, et je me suis dit que ça te ferait marrer 😆 `,
    media:{type:"VIDEO", source:{url:v030, type:"video/mp4"}}},
  {subtitle:"Déjà le mois de Martz qui arrive ?",
    text:`On rigole, mais le temps Pascal !`,
    media:{type:"IMAGE", source:{url:p029}}},
  {subtitle:"Ah non, c'est le mois de Marc, pardon !",
    text:`Et le mois prochain sera le mois pascal !`,
    media:{type:"IMAGE", source:{url:p028}}},
  {subtitle:"Après la Saint-Quentin, les 50 ans !",
    text:`Quelque part en l'an de grâce 2012, un certain groupe nommé Letz Zep jouait à Nantes et tu m'avais proposé d'y aller avec toi.
    Comme à l'époque je ne connaissais que vaguement <i>Stairway to Heaven</i>, j'étais un peu frileux à sortir de ma zone de confort (musicale et camérale), mais tu as insisté un peu, et...<br><br><br><br>
    <h1>NOM DE DIEU QUE TU AS BIEN FAIT !!!!!</h1>
    C'était sûrement une de mes découvertes musicales les plus importantes, qui m'a rappelé qu'il n'y a pas que le metal dans la vie, et j'en ai rempli mon lecteur MP3 les jours suivants !<br>
    Et ce petit extrait, c'est moi qui reviens d'un autre tribute band : Crimson Daze, qui jouait au Ferrailleur en juin 2018 pour les 50 ans du Zep, auquel j'avais amené... Nico !`,
    media:{type:"VIDEO", source:{url:v027, type:"video/mp4"}}},
  {subtitle:"Ils pouvaient pas le faire ailleurs ?",
    text:`Tant qu'à faire, je t'ai retrouvé la vidéo du concert en question : essaie de nous trouver 😉<br>
    <a href="https://dice.fm/event/yovd32-crimson-daze-16th-may-le-ferrailleur-nantes-tickets">Et si jamais, ils passent une dernière fois au Ferrailleur le 16 mai prochain !!</a>`,
    media:{type:"VIDEO", source:{url:v026}}},  
  {subtitle:"With a little ELP from my friends",
    text:`Puisqu'on est dans les découvertes musicales, voici une autre de ta part qui a approfondi ma fascination pour le rock progressif !<br>
    Mais aussi une chanson que j'ai été le <i>seul</i> à trouver pendant le blind test en Corse, un moment dont je ne suis pas peu fier (et j'espère que toi aussi) ! 😎`,
    media:{type:"VIDEO", source:{url:v025}}},
  {subtitle:"Quand t'as l'bourdon, y a Talbourdel !",
    text:`En ces temps troubles, un petit rappel que la paix finit toujours par revenir quand c'est inespéré !<br>
    Et bientôt quand tu en auras marre, go profiter de ta nouvelle liberté ! Qu'est-ce que Tanguy ?`,
    media:{type:"IMAGE", source:{url:p024}}},
  {subtitle:"Pascal Quarantaino présente :",
    text:`Pour les 40 ans de maman, Elvis a meilleure vie !`,
    media:{type:"VIDEO", source:{url:v023}}},
  {subtitle:"Paris scie les Bauchet !",
    text:`Profitons de nos retrouvailles fraternelles à Paris aujourd'hui pour mettre un petit souvenir dans le thème !<br>
    Je parie que nous nantais, en comparaison, on est polis... mais trop polis, 'tain !...`,
    media:{type:"IMAGE", source:{url:p022}}},  
  {subtitle:"Message (et poème) de Blandine !",
    text:`<b>R</b>ester bien au chaud dans son lit,<br>
    <b>E</b>n écoutant chanter la pluie.<br>
    <b>T</b>raîner, muser en son jardin,<br>
    <b>R</b>egarder pousser les lupins.<br>
    <b>A</b>h ! qu'il est doux ce temps joli,<br>
    <b>I</b>l est venu ce jour béni.<br>
    <b>T</b>ravail, contraintes... Ouste ! dehors...<br>
    <b>E</b>ntamons vite l'âge d'or.
    `,
    media:{type:"VIDEO", source:{url:v021, type:"video/mp4"}}},  
  {subtitle:"Alors ? On attend pas Pascal ?",
    text:`Ouais, j'ai vachement planché, pour celle-là...`,
    media:{type:"IMAGE", source:{url:p020}}},
  {subtitle:"Annie thing for you !",
    media:{type:"VIDEO", source:{url:v019, type:"video/mp4"}}},
  {subtitle:"Randonne Access Memories",
    text:`Armé de Derek, mon fidèle bâton, dans les vallées de Granges !`,
    media:{type:"IMAGE", source:{url:p018}}},
  {subtitle:"Les noces Talgie",
    text:`Cette année, c'est vos noces de... papier ?<br>
    Ah bah super, après le rubis et la mousseline, bonjour le budget...<br>
    Mais plus symboliquement encore, ce serait surtout, m'a-t-on dit, les 40 ans de votre rencontre avec maman !<br>
    C'est en juin donc hors-calendrier, mais je tenais à y faire référence quand même avec cette image légendaire !`,
    media:{type:"IMAGE", source:{url:p017}}},
  {subtitle:"Poêle au dos",
    text:`Voilà bien un thème encore non exploré chez les parents Bauchet !<br>
    Peut-être dans la prochaine maison ? Mais avec ou sans, ce sera poilant !`,
    media:{type:"IMAGE", source:{url:p016}}},
  {subtitle:"Si c'est pas Val heureux !",
    text:`Eh mais dis donc, on est déjà dans les quinze derniers jours ?<br>
    Et-ce que ça commence pas à sentir déjà la tranquillité et le tiramisu ?<br>
    Mais ce n'est pas encore le moment de lâcher prise : courage, bientôt le sommet !`,
    media:{type:"IMAGE", source:{url:p015}}},
  {subtitle:"Des racines et des Hellfest",
    text:`En cherchant quelques idées, je suis retombé sur les photos de mes 5 Hellfests...<br>
    Promis, c'est pas moi qui ai écrit tout ça !`,
    media:{type:"IMAGE", source:{url:p014}}},
  {subtitle:"C'est mon dernier Bâle !",
    text:`Attention, transition acrobatique : le mur du rock, pendant notre découverte de Bâle avec Simon !<br>
    On a aussi vu le musée des arts et le musée du papier, qui t'aurait énormément interessé !`,
    media:{type:"IMAGE", source:{url:p013}}},
  {subtitle:"Bah alors, on attend Saint-Patrick ?",
    text:`Me voici sur la fameuse route Arc-en-ciel pour aller chercher mon or ! (vu que le Swatch Group fait pas d'efforts...)<br>
    Joyeuse sympa trick ! 🛹🍀`,
    media:{type:"IMAGE", source:{url:p012}}},
  {subtitle:"Je n'ai jamais vu quelqu'un distribuer autant de tartes à la fois !",
    text:`Nous voilà en plein cours de pâtisserie ! C'est très Chantilly de ta part (de gâteau) !<br>
    La jeune génération semble captivée, c'est bon signe !`,
    media:{type:"IMAGE", source:{url:p011}}},
  {subtitle:"Y a un gros, gros deal dans la piscine !",
    text:`Et bah regarde ça, on y arrive : il reste plus que 10 jours ! Tu les as vus passer, les 90 précédents ?<br>
    Moi pas, mine de rien, avec ce projet : comme tu vois, on est tous un peu sous l'eau en ce moment...<br>
    Mais plus pour longtemps ! Tu vas bientôt pouvoir céder à l'appel de ces sirènes de la détente !`,
    media:{type:"IMAGE", source:{url:p010}}},
  {subtitle:"Message de Renaud Séchiant !",
    text:`Regarde qui est-ce que j'ai réussi à convaincre pour te souhaiter bon vent !<br>
    Merci qui ?`,
    media:{type:"VIDEO", source:{url:v009, type:"video/mp4"}}},
  {subtitle:"Si Pierpoljak était né en Suisse !",
    text:`J'sais pas chanter, aut' chose que du yodel !`,
    media:{type:"VIDEO", source:{url:v008}}},
  {subtitle:"Mamina bonne mine !",
    text:`On s'approche gentiment de la ligne d'arrivée : trinquons à ça et aux beaux jours qui reviennent, et à la bonne santé de nos mamies qui s'y connaissent déjà bien en retraite !<br>
    (Et n'oublions pas d'accepter les cookies !)`,
    media:{type:"IMAGE", source:{url:p007}}},
  {subtitle:"Ça vient Drucker !",
    text:`Dernière angoisse du dimanche soir ?<br>
    Je m'imagine que tes collègues seront comme lui cette semaine !...`,
    media:{type:"VIDEO", source:{url:v006}}},
  {subtitle:"Dernière semaine droite !",
    text:`Un dernier coup de collier et c'est fini ! Tes deux fils les plus endurants te souhaitent bon courage !<br>
    (Le troisième aussi, mais il a préféré s'enfermer à la salle pour réessayer de soulever une à deux fois son poids !)`,
    media:{type:"IMAGE", source:{url:p005}}},
  {subtitle:"Un nouveau cycl(ist)e",
    text:`La retraite, OK, mais il faut penser à passer le flambeau (le lavabo !)<br>
    C'est maintenant chose fête !`,
    media:{type:"IMAGE", source:{url:p004}}},
  {subtitle:"AC/Dchet présente : Jaille break !",
    text:`Si tu passes à la jaille cette semaine, tu y retrouveras peut-être ce solo brouillon... 🥴<br>
    N'hésite surtout pas à mettre ça sur une bonne enceinte !`,
    media:{type:"VIDEO", source:{url:v003}}},
  {subtitle:"Message de Diandra !",
    text:`Coucou Pascal ! J’espère que ce message te trouve bien.<br>
    Je suis pas très douée pour les mots mais je voulais marquer le coup ! Profite bien de ta retraite bien méritée !
    Tu auras plus de temps pour bricoler et pâtisser mais surtout… pour profiter de ta jolie petite famille et de tes enfants.<br>
    La famille est le bien le plus précieux que la Vie nous a offert ici-bas 😌<br>
    Allez, à bientôt Pascal !`,
    media:{type:"IMAGE", source:{url:p002}}},
  {subtitle:"ONE MORE TIME !!!",
    text:`THIS IS IT<br>
    THE LAST FUCKING DAY OF WORK<br>
    METS ÇA À FOND ET MONTRE-LEUR QUI C'EST LE BOSS (ET QUI C'EST QUI BOSSE PLUS) !!<br>
    Et après on te donnera une grande tape symbolique dans le dos, et on boira tous un coup à ta bonne santé !`,
    media:{type:"VIDEO", source:{url:v001}}},
  {subtitle:"Assez bossé !",
    text:`Et le mot de la fin est signé Clément, d'AC/Bauchet !<br>
    Allez, tchô bonne !`,
    media:{type:"VIDEO", source:{url:v000}}},
]

// var waitContent = {
//   subtitle:"En retard !", text:"Normalement il devrait y avoir quelque chose ici, mais j'ai oublié de le mettre...<br>Faut pas hésiter à venir me secouer sur Messenger !", media:{type:"IMAGE", source:{url:"https://www.museumtv.art/wp-content/uploads/2021/05/E5EA565D-7ADE-43FF-B762-844F60CFAE23-1024x778.jpeg"}}
// }
var waitContent = {
  subtitle:"Reviens ce soir !", text:"", media:{type:"IMAGE", source:{url:"https://img.freepik.com/vecteurs-libre/bientot-banniere-lumieres-mise-au-point_1017-33739.jpg"}}
}

var lockedContent = {
  subtitle:"Pas encore ouvert !", text:"", media:{type:"IMAGE", source:{url:"https://i.imgur.com/FDA4vAA.jpeg"}}
}

function buildItem(num, date, content, locked) {
  return {
    num: num,
    date: date,
    locked: locked,
    cardTitle: date.toLocaleString("fr-CH", {dateStyle: "full"}),
    cardSubtitle: content.subtitle || "",
    cardDetailedText: content.text,
    media: content.media
  }
}

export default function buildAllItems() {
  var allItems = [];
  var today = new Date();
  var date = new Date("2025-04-01");
  var num;
  for (var i = 0; i < 53; i++) {
    num = 100-i;
    date = new Date("2025-04-01");
    date.setDate(date.getDate()-num);
    allItems.push(buildItem(num, date, contents_1[i], false));
  }

  //Changement de date
  for (var j = 0; j < 3; j++) {
    num = 47-j;
    date = new Date("2025-04-01");
    date.setDate(date.getDate()-num);
    allItems.push(buildItem('!#?', date, wtfContents[j], false));
  }

  for (var k = 0; k <= 41; k++) {
    num = 41-k;
    date = new Date("2025-03-29");
    date.setDate(date.getDate()-num);
    //Si dépassement de date : afficher ?¿?¿
    //Si dépassement de tableau : afficher retard
    if (today < date && !window.location.toString().includes("localhost")) {
      allItems.push(buildItem(num, date, lockedContent, true));
    } else if (k < contents_2.length) {
      allItems.push(buildItem(num, date, contents_2[k], false));
    } else {
      allItems.push(buildItem(num, date, waitContent, true));
    }
  }

  return allItems;
}
